import { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { NumericFormat } from 'react-number-format'

import { HelpIcon, TooltipText } from '../../../components'
import ProfileCard from '../ProfileCard'
import ProfileField, { ProfileFieldHeading } from '../ProfileField'
import { FieldGroup } from '../ProfileStyle'

class ContactInfoCard extends Component {
  render() {
    const {
      features,
      contactInfo,
      communicationPreferences,
      hasPlanAccess,
      config: { isRetail },
    } = this.props.store

    const hasMobilePhone = Boolean(contactInfo.mobilePhone)
    const hasDaytimePhone = Boolean(contactInfo.phone)
    const hasAnyPhone = hasMobilePhone || hasDaytimePhone
    const showEmptyPhone = hasPlanAccess && !hasAnyPhone
    // Show one placeholder when phone numbers are editable but empty; otherwise show only saved numbers.
    const showMobile = features.enableMobilePhone && (hasMobilePhone || showEmptyPhone)
    const showDaytimePhone = features.enableDaytimePhone && hasDaytimePhone
    const hasAddress =
      contactInfo.mailingAddress1 ||
      contactInfo.mailingAddress2 ||
      contactInfo.mailingCity ||
      contactInfo.mailingState ||
      contactInfo.mailingCountry ||
      contactInfo.mailingZip
    const showAddress = features.enableAddress && !isRetail && (hasPlanAccess || hasAddress)

    return (
      <ProfileCard
        title='Contact & communications'
        handleEdit={hasPlanAccess ? this.props.showContactInfo : undefined}>
        <FieldGroup>
          <ProfileField label='Contact email' value={contactInfo.email} />
        </FieldGroup>

        {(showMobile || showDaytimePhone) && (
          <FieldGroup>
            {showMobile && (
              <ProfileField
                label={hasMobilePhone ? 'Mobile' : 'Phone'}
                value={
                  hasMobilePhone ? (
                    <NumericFormat
                      displayType='text'
                      format='(###) ###-####'
                      value={contactInfo.mobilePhone}
                    />
                  ) : (
                    'None provided'
                  )
                }
              />
            )}
            {showDaytimePhone && (
              <ProfileField
                label='Daytime, extension'
                value={
                  <NumericFormat
                    displayType='text'
                    format={`(###) ###-####${contactInfo.phoneExtension ? ' x######' : ''}`}
                    value={contactInfo.phone + contactInfo.phoneExtension}
                  />
                }
              />
            )}
          </FieldGroup>
        )}

        {showAddress && (
          <FieldGroup>
            <ProfileField
              label='Address'
              value={
                hasAddress ? (
                  <div>
                    {contactInfo.mailingAddress1 && (
                      <>
                        {contactInfo.mailingAddress1}
                        <br />
                      </>
                    )}
                    {contactInfo.mailingAddress2 && (
                      <>
                        {contactInfo.mailingAddress2}
                        <br />
                      </>
                    )}
                    {contactInfo.mailingCity && (
                      <>
                        {contactInfo.mailingCity}
                        <br />
                      </>
                    )}
                    {(contactInfo.mailingState || contactInfo.mailingZip) && (
                      <>
                        {[contactInfo.mailingState, contactInfo.mailingZip]
                          .filter(Boolean)
                          .join(' ')}
                        <br />
                      </>
                    )}
                    {contactInfo.mailingCountry && (
                      <>
                        {contactInfo.mailingCountry}
                        <br />
                      </>
                    )}
                  </div>
                ) : (
                  'None provided'
                )
              }
            />
          </FieldGroup>
        )}

        <FieldGroup>
          <ProfileFieldHeading>
            Electronic delivery consent{' '}
            <HelpIcon size='mediumLarge' tooltip={TooltipText.electronicDeliveryConsent()} />
          </ProfileFieldHeading>
          {!isRetail && (
            <ProfileField
              label='GuidedChoice annual summary'
              value={communicationPreferences.RECEIVE_ELECTRONIC_STATEMENTS ? 'On' : 'Off'}
            />
          )}
          <ProfileField
            label='Email communications'
            value={communicationPreferences.RECEIVE_MARKETING_EMAILS ? 'On' : 'Off'}
          />
        </FieldGroup>
      </ProfileCard>
    )
  }
}

export default inject('store')(observer(ContactInfoCard))
